<script setup>
import { ref } from 'vue';
import { collectionV2 } from '@/composables/resource';
import ProfileLink from '@/components/Link/ProfileLink.vue';
import UserCard from '@/components/User/UserCard.vue';
import Pill from '@/components/Pills/Pill.vue';
import PillGroup from '@/components/Pills/PillGroup.vue';

const views = [
    {
        key: 'accepted',
        label: 'Accepted',
        collection: collectionV2({
            url: '/api/user-connections',
            params: {
                filters: {
                    accepted: true,
                },
            },
        }),
    },
    {
        key: 'pending',
        label: 'Pending',
        collection: collectionV2({
            url: '/api/user-connections',
            params: {
                filters: {
                    accepted: false,
                },
            },
        }),
    },
    {
        key: 'suggestions',
        label: 'Suggestions',
        collection: collectionV2({
            url: '/api/user-connect-suggestions',
        }),
    },
];

const dataViewEl = ref();
</script>

<template>

    <layout-main>
        <layout-content>
            <content-header>
                <top-nav>
                    <top-nav-back />
                    <top-nav-title>Connections</top-nav-title>
                    <div class="grow"></div>
                    <app-collection-query-view-trigger v-if="dataViewEl" :data-view="dataViewEl.dataView" />
                </top-nav>
            </content-header>

            <content-body>
                <div class="px-4 mt-6">
                    <app-collection-view
                        ref="dataViewEl"
                        :views="views"
                        v-slot="{ activeView }"
                    >

                        <ul class="flex flex-col gap-2">
                            <li v-for="data in activeView.data" :key="data.id">
                                <ProfileLink :profile="activeView.key !== 'suggestions' ? data.profile : data.suggested_user.profile">
                                    <UserCard :user="activeView.key !== 'suggestions' ? data : data.suggested_user" />
                                </ProfileLink>
                            </li>
                        </ul>
                    </app-collection-view>
                </div>
            </content-body>
        </layout-content>
    </layout-main>
</template>
